import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { PlessDialogServiceSub } from '../../kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../kymw00/pless-view-utils-sub.service';
import { KYMW00Model } from '../../kymw00/kymw00.model';
import { KYMW0906Model } from './kymw0906.model';
import { FlexGrid } from '@grapecity/wijmo.grid';
import { EventArgs } from '@grapecity/wijmo';
import { KYMW0906InputModel } from './vo/kymw0906-input.model';
import { KYMW0906OutputModel } from './vo/kymw0906-output.model';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';


/**
 * 予約商品設定画面を管理するクラス
 *
 * @export KYMW0906Component
 * @class KYMW0906Component
 */
@Component({
  selector: 'app-kymw0906',
  templateUrl: 'kymw0906.component.html',
  styleUrls: ['kymw0906.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW0906Component extends PlessViewHelperSub implements OnInit {
  param: any;
  setKYMW0906Parameter: Function;
  kymw0906Model: KYMW0906Model = new KYMW0906Model();
  
  // 会員タブでアイテムコードが選択されている生協リスト
  public enableCoopList = [];

  @ViewChild('dtg_GoodsPlanNumList', { static: true }) dtg_GoodsPlanNumList: FlexGrid;

  closeFunction: Function;

  isComposing = false;

  /**
   *Creates an instance of KYMW0906Component.
   * @param {PlessDialogServiceSub} dialogServiceSub
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW0906Component
   */
  constructor(
    private dialogServiceSub: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW0906';

    // グリッドの初期選択行はなしとする
    this.dtg_GoodsPlanNumList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dtg_GoodsPlanNumList.select(-1, -1);
    });

    // グリッド内チェックボックスはセルのクリックでON/OFF可能とする
    this.dtg_GoodsPlanNumList.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      const ht = this.dtg_GoodsPlanNumList.hitTest(e);
      if (ht.target.className === 'goods_plan_num_list_all_check') {
        document.getElementById(`chk_goods_plan_num_list_all_check`).click();
      } else if ((0 <= ht.row) && (0 == ht.col) && !ht.target.className.includes('header-checkbox')) {
        document.getElementById(`goods_plan_num_list_check_${ht.row}`).click();
      }
    });
  }

  /**
   * 親画面に対して公開し、親画面からのパラメタを受け取るためのメソッド
   *
   * @param {*} param 受け渡すデータ
   */
  public setInterfaceParam(param: KYMW0906InputModel): void {
    this.kymw0906Model.mode = param.mode;
    if (this.isAddMode()) {
      this.kymw0906Model.registeredDeliveryCatalogAndItemCodeList = param.registeredDeliveryCatalogAndItemCodeList;
      this.kymw0906Model.bundleEndDeliveryOrder = param.bundleEndDeliveryOrder;
      this.kymw0906Model.beforeChangeDelivCatalog = '';
      this.kymw0906Model.beforeChangeItemCode = '';
      this.kymw0906Model.itemCodeList = param.itemCodeList;
      this.kymw0906Model.selectedItemCode = param.selectedItemCode;
      this.kymw0906Model.enableCoopByItemCodeList = param.enableCoopByItemCodeList;
      this.kymw0906Model.preOrderOrderNumQuotaCodeList = param.preOrderOrderNumQuotaCodeList;
      this.kymw0906Model.preOrderNumQuotaCode = param.preOrderNumQuotaCode;
      this.kymw0906Model.preOrderGoodsName = param.preOrderGoodsName;
      this.kymw0906Model.preOrderGoodsNameKana = param.preOrderGoodsNameKana;
      this.kymw0906Model.preOrderStandardName = param.preOrderStandardName;
      this.kymw0906Model.preOrderStandardNameKana = param.preOrderStandardNameKana;
      this.kymw0906Model.orderNum = param.orderNum;
      this.kymw0906Model.delivMonday = true;
      this.kymw0906Model.delivTuesday = true;
      this.kymw0906Model.delivWednesday = true;
      this.kymw0906Model.delivThursday = true;
      this.kymw0906Model.delivFriday = true;
      this.kymw0906Model.setPreOrderType = false;
      this.kymw0906Model.supplyPriceStandard = param.supplyPriceStandard;
      this.kymw0906Model.pricePattern = param.pricePattern;
      this.kymw0906Model.supplyPriceList = param.preOrderSupplyPriceList;
      this.kymw0906Model.discountType = '0';
      this.kymw0906Model.discountSupplyUnitPrice = param.discountSupplyUnitPrice;
      this.kymw0906Model.catalogAndItemRelatedCoop = param.catalogAndItemRelatedCoop;
      // アイテムコードに紐づく会員生協（取扱可能生協）
      this.kymw0906Model.itemRelatedCoop = param.itemRelatedCoop;
      this.kymw0906Model.itemRelatedCoop_CoopTab = param.itemRelatedCoop_CoopTab;
      // 会員タブでアイテムコードが選択されている生協リスト
      this.enableCoopList = param.enabledCoopList;
      for (const e of param.goodsPlanNumList) {
        this.kymw0906Model.goodsPlanNumList.push({
          coopName: e.coopName,
          coopCode: e.coopCode,
          planNum: e.planNum,
          registFlg: e.registFlg,
          deleteFlg: e.deleteFlg,
          checked: e.checked,
          disabled: !this.enableCoopList.includes(e.coopCode)
        })
      }
      // アイテムコードに紐づく会員生協をチェック
      this.eventItemCode_CHANGEHandler();
    } else if (this.isDetailMode() || this.isReadOnlyMode()) {
      // 登録済みの配達企画回とアイテムコードリストから指定の配達企画回・アイテムコードのセットを削除
      // 設定ボタン押下時に配達企画回が変更されていなかった場合に登録済みバリデーションの対象から除外するため
      this.kymw0906Model.registeredDeliveryCatalogAndItemCodeList = param.registeredDeliveryCatalogAndItemCodeList.filter(e => {
        if (e.delivCatalog === param.deliveryCatalog && e.itemCode === param.selectedItemCode) {
          return false;
        } else {
          return true;
        }
      });
      this.kymw0906Model.deliveryCatalog = param.deliveryCatalog;
      this.kymw0906Model.beforeChangeDelivCatalog = this.kymw0906Model.deliveryCatalog;
      this.kymw0906Model.bundleEndDeliveryOrder = param.bundleEndDeliveryOrder;
      this.kymw0906Model.selectedItemCode = param.selectedItemCode;
      this.kymw0906Model.itemCodeList = param.itemCodeList;
      this.kymw0906Model.enableCoopByItemCodeList = param.enableCoopByItemCodeList;
      this.kymw0906Model.preOrderNumQuotaCode = param.preOrderNumQuotaCode;
      this.kymw0906Model.preOrderOrderNumQuotaCodeList = param.preOrderOrderNumQuotaCodeList;
      this.kymw0906Model.orderNum = param.orderNum;
      this.kymw0906Model.delivMonday = param.delivMonday;
      this.kymw0906Model.delivTuesday = param.delivTuesday;
      this.kymw0906Model.delivWednesday = param.delivWednesday;
      this.kymw0906Model.delivThursday = param.delivThursday;
      this.kymw0906Model.delivFriday = param.delivFriday;
      this.kymw0906Model.preOrderGoodsName = param.preOrderGoodsName;
      this.kymw0906Model.preOrderGoodsNameKana = param.preOrderGoodsNameKana;
      this.kymw0906Model.preOrderStandardName = param.preOrderStandardName;
      this.kymw0906Model.preOrderStandardNameKana = param.preOrderStandardNameKana;
      this.kymw0906Model.setPreOrderType = param.setPreOrderType;
      this.kymw0906Model.supplyPriceStandard = param.supplyPriceStandard;
      this.kymw0906Model.pricePattern = param.pricePattern;
      this.kymw0906Model.supplyPriceList = param.preOrderSupplyPriceList;
      this.kymw0906Model.discountType = param.discountType;
      this.kymw0906Model.discountUnitPrice = param.discountUnitPrice;
      this.kymw0906Model.discountRate = param.discountRate;
      if (this.kymw0906Model.discountType !== '0') {
        // 値引区分が「0:値引なし」以外の場合は受け取った値引後供給単価を格納
        this.kymw0906Model.discountSupplyUnitPrice = param.discountSupplyUnitPrice;
      } else {
        // 値引区分が「0:値引なし」の場合は受け取った値引前供給単価を格納
        this.kymw0906Model.discountSupplyUnitPrice = this.kymw0906Model.supplyPriceStandard;
      }
      this.kymw0906Model.preOrderPoints = param.preOrderPoints;
      this.kymw0906Model.catalogAndItemRelatedCoop = param.catalogAndItemRelatedCoop;
      const enableCoopCodeList = this.kymw0906Model.enableCoopByItemCodeList.find(e => e.ItemCode === this.kymw0906Model.selectedItemCode);
      // アイテムコードに紐づく会員生協（取扱可能生協）
      this.kymw0906Model.itemRelatedCoop = param.itemRelatedCoop;
      // 会員タブでアイテムコードが選択されている生協リスト
      this.enableCoopList = param.enabledCoopList;

      for (const e of param.goodsPlanNumList) {
        // 生協の活性・非活性を判定
        let disabledFlg = false;
        // 取扱可能生協ではない場合、もしくは
        // 同一配達企画回の別アイテムコードで設定済みの生協コードの場合disable
        if (!this.enableCoopList.includes(e.coopCode) ||
          enableCoopCodeList.DisableCoopCodeList.includes(e.coopCode)) {
          disabledFlg = true;
        }
        this.kymw0906Model.goodsPlanNumList.push({
          coopName: e.coopName,
          coopCode: e.coopCode,
          planNum: disabledFlg ? '' : e.planNum,
          registFlg: e.registFlg,
          deleteFlg: e.deleteFlg,
          checked: disabledFlg ? false : e.checked,
          disabled: disabledFlg
        })
      }
      // 合計の再計算
      this.planNumAiPrediction_CHANGEHandler();
      // 全選択チェック制御
      this.setGoodsPlanNumListAll();
    }
  }

  /**
   * 追加モードか判定
   */
  public isAddMode(): boolean {
    return this.kymw0906Model.mode === KYMW0906InputModel.MODO_ADD;
  }

  /**
   * 詳細モードか判定
   */
  public isDetailMode(): boolean {
    return this.kymw0906Model.mode === KYMW0906InputModel.MODO_DETAIL;
  }

  /**
   * 閲覧モードか判定
   */
  public isReadOnlyMode(): boolean {
    return this.kymw0906Model.mode === KYMW0906InputModel.MODO_READ_ONLY;
  }

  /**
   * 全生協が非活性か
   */
  public isDisabledAllCoop(): boolean {
    for (const e of this.kymw0906Model.goodsPlanNumList) {
      if (e.coopName !== '合計' && !e.disabled) {
        return false;
      }
    }
    return true;
  }

  /**
   * 共通イベントリスナ
   * 特定の処理がないイベントハンドラで使用、更新フラグを立てる
   */
  public common_CHANGEHandler(): void {
    this.kymw0906Model.isEdited = true;
  }

  /**
   * アイテムコードイベントリスナ
   */
  public eventItemCode_CHANGEHandler(): void {
    if (this.kymw0906Model.beforeChangeItemCode !== '') {
      this.dialogServiceSub.openAlertGetMessage('Q0174', [], e => {
        if (e === PlessAlert.Yes) {
          this.kymw0906Model.beforeChangeItemCode = this.kymw0906Model.selectedItemCode;
          this.changeEnableCoopList();
          this.changeCheckCoopList();
          // 選択したアイテムコードが空の場合、取扱可能生協のみを活性とする
          if (this.kymw0906Model.selectedItemCode === '') {
            this.clearEnableCoopCodeList();
          }

          // 変更したアイテムコードと価格パターンに対応する供給単価を変更
          if (this.kymw0906Model.selectedItemCode !== '') {
            // 供給単価の設定と再計算を行う
            this.pricePattern_CHANGEHandler();
          } else {
            this.kymw0906Model.supplyPriceStandard = '';
          }
        } else {
          this.kymw0906Model.selectedItemCode = this.kymw0906Model.beforeChangeItemCode;
        }
      });
    } else {
      this.kymw0906Model.beforeChangeItemCode = this.kymw0906Model.selectedItemCode;
      this.changeEnableCoopList();
      this.changeCheckCoopList();
      // 変更したアイテムコードと価格パターンに対応する供給単価を変更
      if (this.kymw0906Model.selectedItemCode !== '') {
        // 供給単価の設定と再計算を行う
        this.pricePattern_CHANGEHandler();
      } else {
        this.kymw0906Model.supplyPriceStandard = '';
      }
    }
  }

  /**
   * 一覧の生協ごとの活性/非活性を更新する
   */
  private changeEnableCoopList() {
    // 同一配達企画回、同一アイテムコードかどうかをチェック
    let sameDataFlg = false;
    for (const data of this.kymw0906Model.enableCoopByItemCodeList) {
      if (data.ItemCode === this.kymw0906Model.selectedItemCode &&
        data.DelivCatalog === this.kymw0906Model.deliveryCatalog) {
        sameDataFlg = true;
        break;
      }
    }

    // 同一配達企画回で別アイテムコードで設定済みの場合、非活性
    // 同一配達企画回、同一アイテムコードを選択していた場合、同一商品の設定生協も非活性
    let enableCoopCodeList = <any>[];
    for (const e of this.kymw0906Model.enableCoopByItemCodeList) {
      if (e.ItemCode !== this.kymw0906Model.selectedItemCode &&
        e.DelivCatalog === this.kymw0906Model.deliveryCatalog) {
          enableCoopCodeList.push(e);
      }
      if (e.ItemCode === this.kymw0906Model.selectedItemCode &&
        e.DelivCatalog === this.kymw0906Model.deliveryCatalog) {
          if (sameDataFlg) {
          enableCoopCodeList.push(e);
        }
      }
    }

    for (const e of this.kymw0906Model.goodsPlanNumList) {
      for (let i = 0; i < enableCoopCodeList.length; i++) {
        if (enableCoopCodeList[i].DisableCoopCodeList?.includes(e.coopCode) || !this.enableCoopList.includes(e.coopCode)) {
          e.disabled = true;
          // 非活性の場合、計画数をクリア
          e.planNum = '';
        }
      }
    }
    this.setGoodsPlanNumListAll();
  }

  /**
   * 一覧の生協ごとのチェック可否を更新する
   */
  private changeCheckCoopList() {
    // 選択されているアイテムコードに紐づく会員生協
    let selectedItemRelatedCoop = [];
    this.kymw0906Model.itemRelatedCoop_CoopTab.map(_ => {
      if(_.ItemCode === this.kymw0906Model.selectedItemCode) {
        selectedItemRelatedCoop.push(_.CoopCode);
      }
    });
    let total = 0;
    this.kymw0906Model.goodsPlanNumList.map((_, index) => {
      if(selectedItemRelatedCoop.includes(_.coopCode) && !_.disabled) {
        _.checked = true;
        _.planNum = '';
      } else {
        _.checked = false;
        _.planNum = '';
      }
      this.eventGoodsPlanNumListChk_CLICKHandler(index);
    });
  }

  /**
   * 月曜日チェックボックスイベントリスナ
   */
  public eventPreOrderDetailListChkMonday_CLICKHandler(): void {
    if (this.kymw0906Model.delivMonday) {
      this.kymw0906Model.delivTuesday = true;
      this.kymw0906Model.delivWednesday = true;
      this.kymw0906Model.delivThursday = true;
      this.kymw0906Model.delivFriday = true;
    }
  }

  /**
   * 火曜日チェックボックスイベントリスナ
   */
  public eventPreOrderDetailListChkTuesday_CLICKHandler(): void {
    if (this.kymw0906Model.delivTuesday) {
      this.kymw0906Model.delivWednesday = true;
      this.kymw0906Model.delivThursday = true;
      this.kymw0906Model.delivFriday = true;
    } else {
      this.kymw0906Model.delivMonday = false;
    }
  }

  /**
   * 水曜日チェックボックスイベントリスナ
   */
  public eventPreOrderDetailListChkWednesday_CLICKHandler(): void {
    if (this.kymw0906Model.delivWednesday) {
      this.kymw0906Model.delivThursday = true;
      this.kymw0906Model.delivFriday = true;
    } else {
      this.kymw0906Model.delivMonday = false;
      this.kymw0906Model.delivTuesday = false;
    }
  }

  /**
   * 木曜日チェックボックスイベントリスナ
   */
  public eventPreOrderDetailListChkThursday_CLICKHandler(): void {
    if (this.kymw0906Model.delivThursday) {
      this.kymw0906Model.delivFriday = true;
    } else {
      this.kymw0906Model.delivMonday = false;
      this.kymw0906Model.delivTuesday = false;
      this.kymw0906Model.delivWednesday = false;
    }
  }

  /**
   * 金曜日チェックボックスイベントリスナ
   */
  public eventPreOrderDetailListChkFriday_CLICKHandler(): void {
    if (!this.kymw0906Model.delivFriday) {
      this.kymw0906Model.delivMonday = false;
      this.kymw0906Model.delivTuesday = false;
      this.kymw0906Model.delivWednesday = false;
      this.kymw0906Model.delivThursday = false;
    }
  }

  /**
   * 値引区分イベントリスナ
   */
  public discountType_CHANGEHandler(): void {
    this.kymw0906Model.discountRate = '';
    this.kymw0906Model.discountUnitPrice = '';
    this.kymw0906Model.discountSupplyUnitPrice = this.kymw0906Model.supplyPriceStandard;
  }

  /**
   * 値引単価イベントリスナ
   */
  public eventDiscountUnitPrice_CHANGEHandler(): void {
    this.kymw0906Model.discountSupplyUnitPrice = String(Number(this.kymw0906Model.supplyPriceStandard) - Number(this.kymw0906Model.discountUnitPrice));
  }

  /**
   * 値引率イベントリスナ
   */
  public eventDiscountRate_CHANGEHandler(): void {
    // 小数点以下切り上げ
    this.kymw0906Model.discountSupplyUnitPrice = String(Math.ceil(Number(this.kymw0906Model.supplyPriceStandard) - (Number(this.kymw0906Model.supplyPriceStandard) / 100 * Number(this.kymw0906Model.discountRate))));
  }

  /**
   * 全選択チェックボックスイベントリスナ
   */
  public eventGoodsPlanNumListAll_CLICKHandler(): void {
    const flg = this.kymw0906Model.goodsPlanNumListEnableFlgAll;
    for (const e of this.kymw0906Model.goodsPlanNumList) {
      if (e.coopName !== '合計' && !e.disabled) {
        e.checked = flg;
        if (e.checked) {
          if (e.deleteFlg === '1') {
            e.deleteFlg = '0';
          }
          e.registFlg = '1';
        } else {
          e.planNum = '';
          e.deleteFlg = '1';
          e.registFlg = '0';
        }
      }
    }
    // 合計の再計算
    this.planNumAiPrediction_CHANGEHandler();
  }

  /**
   * 選択チェックボックスイベントリスナ
   */
  public eventGoodsPlanNumListChk_CLICKHandler(index: number): void {
    if (this.kymw0906Model.goodsPlanNumList[index].checked) {
      if (this.kymw0906Model.goodsPlanNumList[index].deleteFlg === '1') {
        this.kymw0906Model.goodsPlanNumList[index].deleteFlg = '0';
      }
      this.kymw0906Model.goodsPlanNumList[index].registFlg = '1';
    } else {
      this.kymw0906Model.goodsPlanNumList[index].planNum = '';
      this.kymw0906Model.goodsPlanNumList[index].deleteFlg = '1';
      this.kymw0906Model.goodsPlanNumList[index].registFlg = '0';
    }

    // 計画数の合計を再計算
    this.planNumAiPrediction_CHANGEHandler();

    this.setGoodsPlanNumListAll();
  }

  /**
   * 全選択チェックボックス制御
   */
  public setGoodsPlanNumListAll(): void {
    // 活性行のすべてのチェックボックスがONの場合のみ全選択チェックボックスをON
    let flg = true;
    for (const e of this.kymw0906Model.goodsPlanNumList) {
      if (e.coopName === '合計') {
        // 全生協が非活性であればfalse
        flg = !this.isDisabledAllCoop();
        continue;
      }
      if (!e.checked && !e.disabled) {
        flg = false;
        break;
      }
    }
    this.kymw0906Model.goodsPlanNumListEnableFlgAll = flg;
  }

  /**
   * 計画数イベントリスナ
   */
  public planNumAiPrediction_CHANGEHandler(): void {
    let total = 0;
    for (const e of this.kymw0906Model.goodsPlanNumList) {
      if (e.coopName !== '合計') {
        if (e.planNum && !e.disabled) {
          total = total + Number(e.planNum);
        }
      } else {
        e.planNum = total === 0 ? '' : String(total);
      }
    }
  }

  /**
   * 「閉じる」
   */
  public eventClose_CLICKHandler(): void {
    // 編集が行われている場合、メッセージを表示
    if (this.kymw0906Model.isEdited) {
      this.dialogServiceSub.openAlertGetMessage('Q0107', ['予約商品設定'], (closeEvent: number) => {
        if (closeEvent === PlessAlert.Yes) {
          this.closeFunction();
        }
      });
    } else {
      this.closeFunction();
    }
  }

  /**
   * 設定ボタンを押下したときに呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   */
  public eventSet_CLICKHandler(): void {
    if (!this.validate()) {
      return;
    }

    // 親画面に反映
    const vo = new KYMW0906OutputModel();
    vo.deliveryCatalog = this.kymw0906Model.deliveryCatalog;
    vo.selectedItemCode = this.kymw0906Model.selectedItemCode;
    vo.preOrderNumQuotaCode = this.kymw0906Model.preOrderNumQuotaCode;
    vo.orderNum = this.kymw0906Model.orderNum;
    vo.delivMonday = this.kymw0906Model.delivMonday;
    vo.delivTuesday = this.kymw0906Model.delivTuesday;
    vo.delivWednesday = this.kymw0906Model.delivWednesday;
    vo.delivThursday = this.kymw0906Model.delivThursday;
    vo.delivFriday = this.kymw0906Model.delivFriday;
    vo.preOrderGoodsName = this.kymw0906Model.preOrderGoodsName;
    vo.preOrderGoodsNameKana = this.kymw0906Model.preOrderGoodsNameKana;
    vo.preOrderStandardName = this.kymw0906Model.preOrderStandardName;
    vo.preOrderStandardNameKana = this.kymw0906Model.preOrderStandardNameKana;
    vo.setPreOrderType = this.kymw0906Model.setPreOrderType;
    vo.pricePattern = this.kymw0906Model.pricePattern;
    vo.supplyPriceStandard = this.kymw0906Model.supplyPriceStandard;
    vo.discountType = this.kymw0906Model.discountType;
    vo.discountUnitPrice = this.kymw0906Model.discountUnitPrice;
    vo.discountRate = this.kymw0906Model.discountRate;
    vo.discountSupplyUnitPrice = this.kymw0906Model.discountSupplyUnitPrice;
    vo.preOrderPoints = this.kymw0906Model.preOrderPoints;
    vo.goodsPlanNumList = this.kymw0906Model.goodsPlanNumList.map((e) => {
      if (e.coopName !== '合計') {
        return {
          coopName: e.coopName,
          coopCode: e.coopCode,
          planNum: e.planNum,
          registFlg: e.registFlg,
          deleteFlg: e.deleteFlg,
          checked: e.checked,
          disabled: e.disabled
        }
      } else {
        return {
          coopName: e.coopName,
          coopCode: e.coopCode,
          planNum: e.planNum,
          registFlg: e.registFlg,
          deleteFlg: e.deleteFlg,
          checked: e.checked,
          disabled: e.disabled
        }
      }
    });
    this.setKYMW0906Parameter(vo);

    this.closeFunction();
  }

  /**
   * 設定ボタン押下時のバリデーション
   */
  private validate(): boolean {
    // 必須チェック
    if (PlessViewUtilsSub.isEmpty(this.kymw0906Model.deliveryCatalog)) {
      this.dialogServiceSub.openAlertGetMessage('E0615', ['予約商品設定']);
      return false;
    }

    if (PlessViewUtilsSub.isEmpty(this.kymw0906Model.selectedItemCode)) {
      this.dialogServiceSub.openAlertGetMessage('E0615', ['予約商品設定']);
      return false;
    }

    if (PlessViewUtilsSub.isEmpty(this.kymw0906Model.preOrderNumQuotaCode) || this.kymw0906Model.preOrderNumQuotaCode === 'blankVal') {
      this.dialogServiceSub.openAlertGetMessage('E0615', ['予約商品設定']);
      return false;
    }

    if (PlessViewUtilsSub.isEmpty(this.kymw0906Model.preOrderGoodsName)) {
      this.dialogServiceSub.openAlertGetMessage('E0615', ['予約商品設定']);
      return false;
    }

    if (PlessViewUtilsSub.isEmpty(this.kymw0906Model.preOrderGoodsNameKana)) {
      this.dialogServiceSub.openAlertGetMessage('E0615', ['予約商品設定']);
      return false;
    }

    if (PlessViewUtilsSub.isEmpty(this.kymw0906Model.preOrderStandardName)) {
      this.dialogServiceSub.openAlertGetMessage('E0615', ['予約商品設定']);
      return false;
    }

    if (PlessViewUtilsSub.isEmpty(this.kymw0906Model.preOrderStandardNameKana)) {
      this.dialogServiceSub.openAlertGetMessage('E0615', ['予約商品設定']);
      return false;
    }

    if (PlessViewUtilsSub.isEmpty(this.kymw0906Model.discountType)) {
      this.dialogServiceSub.openAlertGetMessage('E0615', ['予約商品設定']);
      return false;
    }

    if (PlessViewUtilsSub.isEmpty(this.kymw0906Model.supplyPriceStandard)) {
      this.dialogServiceSub.openAlertGetMessage('E0615', ['予約商品設定']);
      return false;
    }

    // 配達企画回とアイテムコードが既に登録されているか
    for (const data of this.kymw0906Model.registeredDeliveryCatalogAndItemCodeList) {
      if (data.delivCatalog === this.kymw0906Model.deliveryCatalog && data.itemCode === this.kymw0906Model.selectedItemCode) {
        this.dialogServiceSub.openAlertGetMessage('E0115', ['配達企画回とアイテムコード']);
        return false;
      }
    }

    // 配達企画曜日の月～金がすべて未選択でないか
    // 配達企画曜日の開始曜日から金曜まで連続してチェックが付いているか
    if (this.kymw0906Model.delivMonday) {
      if (!(this.kymw0906Model.delivTuesday && this.kymw0906Model.delivWednesday && this.kymw0906Model.delivThursday && this.kymw0906Model.delivFriday)) {
        this.dialogServiceSub.openAlertGetMessage('E0576', null);
        return false;
      }
    } else if (this.kymw0906Model.delivTuesday) {
      if (!(this.kymw0906Model.delivWednesday && this.kymw0906Model.delivThursday && this.kymw0906Model.delivFriday)) {
        this.dialogServiceSub.openAlertGetMessage('E0576', null);
        return false;
      }
    } else if (this.kymw0906Model.delivWednesday) {
      if (!(this.kymw0906Model.delivThursday && this.kymw0906Model.delivFriday)) {
        this.dialogServiceSub.openAlertGetMessage('E0576', null);
        return false;
      }
    } else if (this.kymw0906Model.delivThursday) {
      if (!(this.kymw0906Model.delivFriday)) {
        this.dialogServiceSub.openAlertGetMessage('E0576', null);
        return false;
      }
    } else if (!this.kymw0906Model.delivFriday) {
      this.dialogServiceSub.openAlertGetMessage('E0617', null);
      return false;
    }

    // 値引区分が「1：単価指定」かつ値引単価が未設定または値引単価が0でないか
    // 値引区分が「1：単価指定」かつ値引単価 > 今回供給価格でないか
    if (this.kymw0906Model.discountType === '1') {
      if (PlessViewUtilsSub.isEmpty(this.kymw0906Model.discountUnitPrice) || Number(this.kymw0906Model.discountUnitPrice) === 0) {
        this.dialogServiceSub.openAlertGetMessage('E0577', null);
        return false;
      }

      if (Number(this.kymw0906Model.discountUnitPrice) > Number(this.kymw0906Model.supplyPriceStandard)) {
        this.dialogServiceSub.openAlertGetMessage('E0618', null);
        return false;
      }
    }

    // 値引区分が「2：率指定」かつ値引率が未設定または値引率が1～100の範囲外の場合
    if (this.kymw0906Model.discountType === '2') {
      const discountRate = Number(this.kymw0906Model.discountRate)
      if (!(discountRate > 0 && discountRate <= 100)) {
        this.dialogServiceSub.openAlertGetMessage('E0579', null);
        return false;
      }
    }

    // 付与ポイントが入力されていた場合、付与ポイント < 1 でないか
    if (!PlessViewUtilsSub.isEmpty(this.kymw0906Model.preOrderPoints) &&
      Number(this.kymw0906Model.preOrderPoints) < 1) {
      this.dialogServiceSub.openAlertGetMessage('E0582', null);
      return false;
    }

    // 付与ポイント > 今回供給価格 でないか
    if (Number(this.kymw0906Model.preOrderPoints) > Number(this.kymw0906Model.supplyPriceStandard)) {
      this.dialogServiceSub.openAlertGetMessage('E0619', null);
      return false;
    }

    // 会員生協が1つ以上選択されているか
    if (!this.kymw0906Model.goodsPlanNumList.some(e => e.checked)) {
      this.dialogServiceSub.openAlertGetMessage('E0616', null);
      return false;
    }

    // チェックされた会員生協の計画数が入力されているか
    for (const data of this.kymw0906Model.goodsPlanNumList) {
      if (data.checked) {
        // 計画数が空の場合
        if (PlessViewUtilsSub.isEmpty(data.planNum)) {
          this.dialogServiceSub.openAlertGetMessage('E0106', ['利用都県', '計画数']);
          return false;
        }
        // 計画数が0以下の場合
        if (PlessViewUtilsSub.stringToNumber(data.planNum) <= 0) {
          this.dialogServiceSub.openAlertGetMessage('E0142', ['計画数', '1']);
          return false;
        }
      }
    }

    // 配達企画回に対応する受注コード < 束ね企画回の終了受注コードでないか
    if (Number(this.kymw0906Model.deliveryOrderCode) < Number(this.kymw0906Model.bundleEndDeliveryOrder)) {
      this.dialogServiceSub.openAlertGetMessage('E0625', null);
      return false;
    }

    return true;
  }

  /**
   * 注文コード割当変更時のメソッド
   */
  public preOrderNumQuotaCode_CHANGEHandler(): void {
    this.kymw0906Model.orderNum = '';
  }

  /**
   * 配達企画回のフォーカスアウト時のメソッド
   */
  public eventDelivCatalog_FOCUS_OUTHandler(): void {
    // 前の入力値と変更されていた場合のみ処理が動く
    if (this.kymw0906Model.beforeChangeDelivCatalog !== this.kymw0906Model.deliveryCatalog) {
      // 配達企画回とアイテムコードが選択されていない場合、取扱可能生協のみを活性とする
      if (PlessViewUtilsSub.isEmpty(this.kymw0906Model.deliveryCatalog) ||
        PlessViewUtilsSub.isEmpty(this.kymw0906Model.selectedItemCode)) {
        this.clearEnableCoopCodeList();
      } else {
        // 同一配達企画回、同一アイテムコードかどうかをチェック
        let sameDataFlg = false;
        for (const data of this.kymw0906Model.enableCoopByItemCodeList) {
          if (data.ItemCode === this.kymw0906Model.selectedItemCode &&
            data.DelivCatalog === this.kymw0906Model.deliveryCatalog) {
            sameDataFlg = true;
            break;
          }
        }

        let settedCoopList = [];
        this.kymw0906Model.catalogAndItemRelatedCoop.map(_ => {
          if(_.delivCatalogId === this.kymw0906Model.deliveryCatalog && _.itemCode !== this.kymw0906Model.selectedItemCode) {
            // 同配達企画回の別アイテムコードでチェックされている生協を取得
            _.preOrderCoopList.map(c => {
              if(c.checked || !PlessViewUtilsSub.isEmpty(c.planNum)) {
                settedCoopList.push(c.coopCode);
              }
            });
          }
          if (this.isAddMode() && _.delivCatalogId === this.kymw0906Model.deliveryCatalog && _.itemCode === this.kymw0906Model.selectedItemCode) {
            // 追加時、同配達企画回の同アイテムコードでチェックされている生協を取得
            if (sameDataFlg) {
            _.preOrderCoopList.map(c => {
              if(c.checked || !PlessViewUtilsSub.isEmpty(c.planNum)) {
                settedCoopList.push(c.coopCode);
              }
            });
          }
        }
        });
        this.kymw0906Model.goodsPlanNumList.map(c => {
          // 取得した生協に含まれるか、取扱可能生協ではない場合は非活性とする
          if (settedCoopList.includes(c.coopCode) || !this.enableCoopList.includes(c.coopCode)) {
            c.disabled = true;
            c.checked = false;
            c.planNum = '';
          } else {
            c.disabled = false;
          }
        });

        this.setGoodsPlanNumListAll();
      }
    }

    this.kymw0906Model.beforeChangeDelivCatalog = this.kymw0906Model.deliveryCatalog;

    // 合計の再計算
    this.planNumAiPrediction_CHANGEHandler();
  }

  /** 
   * 生協のチェックボックスの非活性を初期状態にする（取扱可能生協のみ活性）メソッド
   * 配達企画回、アイテムコードをクリアした時に使用する
   */
  public clearEnableCoopCodeList(): void {
    for (const e of this.kymw0906Model.goodsPlanNumList) {
      if (!this.enableCoopList.includes(e.coopCode)) {
        e.disabled = true;
        e.checked = false;
        e.planNum = '';
      } else {
        e.disabled = false;
        e.checked = false;
        e.planNum = '';
      }
    }
    // 全選択チェック制御
    this.setGoodsPlanNumListAll();
  }

  /**
   * 専用商品名(カナ)の入力から半角カンマを削除
   */
  public eventPreOrderGoodsNameKana_deleteCommaHandler(): void {
    this.kymw0906Model.preOrderGoodsNameKana = this.kymw0906Model.preOrderGoodsNameKana.replace(/,/g, '');
  }

  /**
   * 専用規格名(カナ)の入力から半角カンマを削除
   */
  public eventPreOrderStandardNameKana_deleteCommaHandler(): void {
    this.kymw0906Model.preOrderStandardNameKana = this.kymw0906Model.preOrderStandardNameKana.replace(/,/g, '');
  }

  onCompStart() {
    this.isComposing = true;
  }
  // 全角入力から半角カンマに変換した時に削除するためのメソッド
  onCompDeleteCommaEnd(e: Event) {
    this.isComposing = false;
    (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.replace(/,/g, '');
  }

  /**
   * 値引前供給単価変更時のイベント
   */
  public eventSupplyPrice_CHANGEHandler(): void {
    // 値引後供給単価を再計算
    this.calcDiscountSupplyUnitPrice();
  }

  /**
   * 価格パターン変更時のイベント
   */
  public pricePattern_CHANGEHandler(): void {
    // 選択した価格パターンに対応する価格を値引前供給単価に設定後、値引後供給単価を再計算
    const targetItemSupplyList = this.kymw0906Model.supplyPriceList.find(_ => _.itemCode === this.kymw0906Model.selectedItemCode);
    let tempSupplyPrice = '';
    if (targetItemSupplyList) {
      switch (this.kymw0906Model.pricePattern) {
        // ①【0:通常】の場合
        case '0':
          tempSupplyPrice = targetItemSupplyList.supplyPriceStandard;
          break;
        // ②【1:特価１】の場合
        case '1':
          tempSupplyPrice = targetItemSupplyList.supplyPriceSpecial1;
          break;
        // ③【2:特価２】の場合
        case '2':
          tempSupplyPrice = targetItemSupplyList.supplyPriceSpecial2;
          break;
        // ④【3:特価３】の場合
        case '3':
          tempSupplyPrice = '';
          break;
      }
    } else {
      tempSupplyPrice = '';
    }
    // 値引前供給単価を設定
    this.kymw0906Model.supplyPriceStandard = tempSupplyPrice;
    this.calcDiscountSupplyUnitPrice();
  }

  /**
   * 値引後供給単価を計算して設定するイベント
   */
  public calcDiscountSupplyUnitPrice(): void {
    // 値引後供給単価を再計算
    if (PlessViewUtilsSub.isEmpty(this.kymw0906Model.supplyPriceStandard)) {
      // 値引前供給単価が空白の場合は値引後供給単価を空白にする
      this.kymw0906Model.discountSupplyUnitPrice = '';
    } else {
      if (this.kymw0906Model.discountType === '0') {
        this.kymw0906Model.discountSupplyUnitPrice = this.kymw0906Model.supplyPriceStandard;
      } else if (this.kymw0906Model.discountType === '1') {
        this.eventDiscountUnitPrice_CHANGEHandler();
      } else if (this.kymw0906Model.discountType === '2') {
        this.eventDiscountRate_CHANGEHandler();
      }
    }
  }
}
